import {type EndGameData} from '@colonist/game-base-types'
import {type TranslationObject} from '@colonist/i18n'

export enum RankedUserStateType {
    Placement,
    Ranked,
    RankedLocked,
}

export abstract class BaseRankedUserState {
    abstract readonly type: RankedUserStateType

    abstract getEndGameScreenText(): { title: TranslationObject, description: TranslationObject }
    abstract getEndGameData(): EndGameData
    abstract getFindGamePopupStatusText(): TranslationObject
}
